"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiEndpoint;
(function (ApiEndpoint) {
    ApiEndpoint["Channel"] = "operation/:operationId/channel";
    ApiEndpoint["ChannelOne"] = "operation/:operationId/channel/:channelId";
    ApiEndpoint["Client"] = "client";
    ApiEndpoint["ClientOne"] = "client/:clientId";
    ApiEndpoint["HardwareIdentifier"] = "hardware-identifier";
    ApiEndpoint["HardwareIdentifierOne"] = "hardware-identifier/:hardwareIdentifierId";
    ApiEndpoint["Language"] = "language";
    ApiEndpoint["LanguageOne"] = "language/:id";
    ApiEndpoint["Operation"] = "client/:clientId/operation";
    ApiEndpoint["OperationOne"] = "client/:clientId/operation/:operationId";
    ApiEndpoint["PublicAuthLogin"] = "auth/login";
    ApiEndpoint["Route"] = "operation/:operationId/route";
    ApiEndpoint["RouteOne"] = "operation/:operationId/route/:routeId";
    ApiEndpoint["RouteStop"] = "operation/:operationId/route/:routeId/stop";
    ApiEndpoint["RouteStopOne"] = "operation/:operationId/route/:routeId/stop/:stopId";
    ApiEndpoint["StatisticLanguage"] = "statistic/language-choice";
    ApiEndpoint["StatisticAvgOccupancy"] = "statistic/average-occupancy";
    ApiEndpoint["StatisticNotWorkingSeats"] = "statistic/not-working-seats";
    ApiEndpoint["StatisticAvgSpeed"] = "statistic/average-speed";
    ApiEndpoint["User"] = "user";
    ApiEndpoint["UserMe"] = "user/me";
    ApiEndpoint["UserOne"] = "user/:userId";
    ApiEndpoint["Vehicle"] = "operation/:operationId/vehicle";
    ApiEndpoint["VehicleOne"] = "operation/:operationId/vehicle/:vehicleId";
})(ApiEndpoint = exports.ApiEndpoint || (exports.ApiEndpoint = {}));
